import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

/** Props for LoadingPage. */
export interface LoadingPageProps {
    /** Optional context-specific loading text. Defaults to "Loading...". */
    message?: string;
}

/**
 * Full-page loading state component with a MUI CircularProgress spinner and optional message.
 */
function LoadingPage({ message = 'Loading...' }: LoadingPageProps) {
    return (
        <Box
            role="status"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '200px',
                gap: 2,
            }}
        >
            <CircularProgress />
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {message}
            </Typography>
        </Box>
    );
}

export default LoadingPage;
